// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-wrap[data-v-43f01547]{align-items:center;background-color:#fff;display:flex;height:calc(100vh - 100px);justify-content:center;text-align:center;width:100%}.error-inner[data-v-43f01547]{margin-top:0}.title[data-v-43f01547]{color:#0baf00;font-size:24px;font-weight:700;margin-bottom:24px}.btn-link[data-v-43f01547]{background-color:#0baf00;border-radius:5px;color:#fff;padding:8px 20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
